import memoizeWithAllArguments from "@gef-ui/utils/memoizeWithAllArguments";
import path from "ramda/es/path";
import compose from "ramda/es/compose";
import flip from "ramda/es/flip";
import identity from "ramda/es/identity";
import not from "ramda/es/not";
import prop from "ramda/es/prop";
import isNilOrEmpty from "ramda-extension/es/isNilOrEmpty";
import memoizeWithIdentity from "ramda-extension/es/memoizeWithIdentity";
import { createSelector } from 'reselect';
import { REDUCER_NAME } from '../../constants/fieldDescriptor';
/**
 * get field descriptor for given form
 *
 * @documented
 * @category Selector
 * @example
 *
 * 	getFieldDescriptor('formName')(state)
 *
 */ export const getFieldDescriptor = memoizeWithIdentity((formName)=>createSelector(path([
        formName,
        REDUCER_NAME
    ]), identity));
/**
 * get field from descriptor for given form
 *
 * @documented
 * @category Selector
 * @example
 *
 * 	getFieldFromDescriptor('formName')(state)('field')
 *
 */ export const getFieldFromDescriptor = memoizeWithIdentity((formName)=>createSelector([
        getFieldDescriptor(formName)
    ], memoizeWithAllArguments(flip(prop))));
/**
 * field in descriptor has async validations
 *
 * @documented
 * @category Selector
 * @example
 *
 * 	hasAsyncValidations('formName')(state)('field')
 *
 */ export const hasAsyncValidations = memoizeWithIdentity((formName)=>createSelector([
        getFieldDescriptor(formName)
    ], (descriptor)=>(field)=>compose(not, isNilOrEmpty, path([
                field,
                'descriptor',
                'asyncValidations'
            ]))(descriptor)));
